import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from 'moment';
import { NO_EXPIRY_DATE_STRING } from '../../../screens/RewardCenter/constants';
import { REWARD_CENTER_CATEGORY_ICON_TYPE } from '../../../screens/RewardCenter/constants';
import { getOfferBenefitDescription, getOfferCoinsRequired, getOfferCostType, getOfferLoyaltyPoints, isCoinOffer } from '../../../screens/RewardCenter/utils/validations';
import { TEXT_KEY, getText } from '../../../utils/localization';
var adaptRewardCenterOffer = function adaptRewardCenterOffer(offer) {
  var _offer$rid, _offer$thumb, _offer$rname, _offer$maxperplayer, _offer$maxredemption;
  return {
    offerId: (_offer$rid = offer.rid) !== null && _offer$rid !== void 0 ? _offer$rid : offer.r_id,
    offerImage: (_offer$thumb = offer.thumb) !== null && _offer$thumb !== void 0 ? _offer$thumb : offer.thumbnail,
    categoryId: offer.rc_id,
    rewardName: (_offer$rname = offer.rname) !== null && _offer$rname !== void 0 ? _offer$rname : offer.rewardname,
    rewardType: offer.rewardtype,
    loyaltyPoints: getOfferLoyaltyPoints(offer),
    coinsRequired: getOfferCoinsRequired(offer),
    costType: getOfferCostType(offer),
    benefitDescription: getOfferBenefitDescription(offer),
    ribbontype: offer.ribbontype,
    remainingredeems: offer.remainingredeems,
    maxperplayer: (_offer$maxperplayer = offer.maxperplayer) !== null && _offer$maxperplayer !== void 0 ? _offer$maxperplayer : 0,
    maxredemption: (_offer$maxredemption = offer.maxredemption) !== null && _offer$maxredemption !== void 0 ? _offer$maxredemption : 0,
    isNew: offer.is_new
  };
};
var formatLoyaltyExpiry = function formatLoyaltyExpiry(loyaltyExpiryDate) {
  var expiryDate = moment(loyaltyExpiryDate);
  return expiryDate.isValid() ? expiryDate.format('DD MMM YYYY') : false;
};
var isLoyaltyExpired = function isLoyaltyExpired(loyaltyExpiryDate) {
  var expiryDate = moment(loyaltyExpiryDate);
  return expiryDate.isValid() ? expiryDate.isBefore(moment(), 'day') : false;
};
var normalizeCategoryIconType = function normalizeCategoryIconType(categoryIconType) {
  var fallbackCategoryIconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REWARD_CENTER_CATEGORY_ICON_TYPE.NONE;
  var normalizedCategoryIconType = "".concat(categoryIconType || fallbackCategoryIconType).trim().toUpperCase();
  return Object.values(REWARD_CENTER_CATEGORY_ICON_TYPE).includes(normalizedCategoryIconType) ? normalizedCategoryIconType : REWARD_CENTER_CATEGORY_ICON_TYPE.NONE;
};
export var postRewardCenterAdapter = function postRewardCenterAdapter(response) {
  var _profile$, _profile$2, _profile$3, _profile$4, _profile$5, _profile$6, _profile$7, _profile$8, _profile$0$displayRew, _profile$9, _profile$10, _profile$11;
  var _response$profile = response.profile,
    profile = _response$profile === void 0 ? {} : _response$profile,
    _response$offers = response.offers,
    offers = _response$offers === void 0 ? {} : _response$offers,
    _response$filterList = response.filterList,
    filterList = _response$filterList === void 0 ? {} : _response$filterList,
    otpExpired = response.otpExpired,
    assetsPackageId = response.assetsPackageId;
  var offersList = Object.values(offers);
  var categoriesList = Object.values(filterList);
  var coinCategoryIds = new Set(offersList.filter(isCoinOffer).map(function (offer) {
    return offer.rc_id;
  }));
  var rewardCenterAdapter = {
    profile: {
      name: (_profile$ = profile[0]) === null || _profile$ === void 0 ? void 0 : _profile$.name,
      playerProfileInfo: (_profile$2 = profile[0]) === null || _profile$2 === void 0 ? void 0 : _profile$2.playerProfileInfo,
      loyaltyExpiryDate: formatLoyaltyExpiry((_profile$3 = profile[0]) === null || _profile$3 === void 0 ? void 0 : _profile$3.loyaltyExpiryDate),
      isLoyaltyExpired: isLoyaltyExpired((_profile$4 = profile[0]) === null || _profile$4 === void 0 ? void 0 : _profile$4.loyaltyExpiryDate),
      linkedCasinoId: ((_profile$5 = profile[0]) === null || _profile$5 === void 0 ? void 0 : _profile$5.linkedCasinoId) === 'yes',
      enableOrderCard: ((_profile$6 = profile[0]) === null || _profile$6 === void 0 ? void 0 : _profile$6.enableOrderCard) === 'yes',
      displayRewardProfileScreen: ((_profile$7 = profile[0]) === null || _profile$7 === void 0 ? void 0 : _profile$7.displayRewardProfileScreen) === 'yes' || ((_profile$8 = profile[0]) === null || _profile$8 === void 0 ? void 0 : _profile$8.displayRewardProfileScreen) === true,
      displayRewardHistoryScreen: (_profile$0$displayRew = (_profile$9 = profile[0]) === null || _profile$9 === void 0 ? void 0 : _profile$9.displayRewardHistoryScreen) !== null && _profile$0$displayRew !== void 0 ? _profile$0$displayRew : true,
      displayRewardLoyaltyScreen: (_profile$10 = profile[0]) === null || _profile$10 === void 0 ? void 0 : _profile$10.displayRewardLoyaltyScreen,
      displayFreePlayBalance: (_profile$11 = profile[0]) === null || _profile$11 === void 0 ? void 0 : _profile$11.displayFreePlayBalance
    },
    offers: offersList.map(adaptRewardCenterOffer),
    categories: categoriesList.map(function (category) {
      var _category$title_image, _category$cat_desc;
      var isUseCoinsCategory = coinCategoryIds.has(category === null || category === void 0 ? void 0 : category.rc_id);
      return {
        categoryId: category === null || category === void 0 ? void 0 : category.rc_id,
        categoryName: category === null || category === void 0 ? void 0 : category.cat_name,
        isUseCoinsCategory: isUseCoinsCategory,
        categoryImage: (_category$title_image = category === null || category === void 0 ? void 0 : category.title_image) !== null && _category$title_image !== void 0 ? _category$title_image : category === null || category === void 0 ? void 0 : category.cat_icon,
        categoryIconType: normalizeCategoryIconType(category === null || category === void 0 ? void 0 : category.categoryIconType, isUseCoinsCategory ? REWARD_CENTER_CATEGORY_ICON_TYPE.REDEEM_COINS : REWARD_CENTER_CATEGORY_ICON_TYPE.NONE),
        categoryDescription: (_category$cat_desc = category === null || category === void 0 ? void 0 : category.cat_desc) !== null && _category$cat_desc !== void 0 ? _category$cat_desc : null
      };
    }),
    otpExpired: otpExpired,
    assetsPackageId: assetsPackageId
  };
  return rewardCenterAdapter;
};
export var postOfferDetailAdapter = function postOfferDetailAdapter(response, rewardCenterBaseUrl) {
  var _response$offerDetail = response.offerDetails,
    img1 = _response$offerDetail.img1,
    img2 = _response$offerDetail.img2,
    img3 = _response$offerDetail.img3;
  var images = [img1, img2, img3].filter(Boolean).map(function (img) {
    return "".concat(rewardCenterBaseUrl).concat(img);
  });
  var adaptedOfferDetails = adaptRewardCenterOffer(response.offerDetails);
  return _objectSpread(_objectSpread({}, response), {}, {
    offerDetails: _objectSpread(_objectSpread(_objectSpread({}, response.offerDetails), adaptedOfferDetails), {}, {
      images: images
    })
  });
};
export var postRewardCenterHistoryAdapter = function postRewardCenterHistoryAdapter(response, rewardCenterBaseUrl) {
  var historyArray = [];
  if (typeof response === 'object' && response !== null) {
    historyArray = Object.values(response).map(function (historyItem) {
      return _objectSpread(_objectSpread({}, historyItem), {}, {
        cat_icon: rewardCenterBaseUrl + historyItem.cat_icon,
        date: moment(historyItem.date).format('DD/MM/YYYY')
      });
    });
  }
  return historyArray;
};
export var postRewardOfferHistoryDetailsAdapter = function postRewardOfferHistoryDetailsAdapter(response) {
  var offerHistoryDetailsAdapter = response;
  if (offerHistoryDetailsAdapter.expiryDate === NO_EXPIRY_DATE_STRING) {
    offerHistoryDetailsAdapter.expiryDate = getText(TEXT_KEY.NO_EXPIRY_DATE);
  } else {
    offerHistoryDetailsAdapter.expiryDate = "".concat(getText(TEXT_KEY.EXPIRES_ON), ": ").concat(offerHistoryDetailsAdapter.expiryDate);
  }
  offerHistoryDetailsAdapter.terms = offerHistoryDetailsAdapter.terms.replace(/(?:\r\n|\r|\n)/g, '<br><br>');
  return offerHistoryDetailsAdapter;
};